"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveDataApi = SaveDataApi;
exports.deleteActivityPage = deleteActivityPage;
exports.designListApi = designListApi;
exports.getActivityPageDetail = getActivityPageDetail;
exports.getActivityPageList = getActivityPageList;
exports.getDataApi = getDataApi;
exports.getSolarTerms = getSolarTerms;
exports.getTheme = getTheme;
exports.goodDesignList = goodDesignList;
exports.groupDataList = groupDataList;
exports.groupDelete = groupDelete;
exports.groupEdit = groupEdit;
exports.groupInfo = groupInfo;
exports.groupList = groupList;
exports.groupSave = groupSave;
exports.saveActivityPage = saveActivityPage;
exports.saveSolarTerms = saveSolarTerms;
exports.startActivityPage = startActivityPage;
exports.themeSave = themeSave;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function groupDelete(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/delete',
    method: 'GET',
    params: data
  });
}
function groupInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/info',
    method: 'GET',
    params: data
  });
}
function groupList(pram) {
  var data = {
    keywords: pram.keywords,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/group/list',
    method: 'GET',
    params: data
  });
}
function groupDataList(pram) {
  var data = {
    gid: pram.gid,
    keywords: pram.keywords,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/group/data/list',
    method: 'GET',
    params: data
  });
}
function groupSave(pram) {
  var data = {
    formId: pram.formId,
    info: pram.info,
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/system/group/save',
    method: 'POST',
    params: data
  });
}
function groupEdit(pram) {
  var data = {
    formId: pram.formId,
    info: pram.info,
    name: pram.name,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/update',
    method: 'POST',
    params: data
  });
}

/**
 * @description 页面设计 获取数据
 */
function designListApi() {
  return _request.default.get("/admin/page/layout/index");
}

/**
 * @description 页面设计商品Tab 获取数据
 */
function goodDesignList(pram) {
  var data = {
    gid: pram.gid
  };
  return (0, _request.default)({
    url: '/admin/system/group/data/list',
    method: 'GET',
    params: data
  });
}

/**
 * @description 页面设计 保存
 */
function SaveDataApi(data, url) {
  return (0, _request.default)({
    url: url,
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取配置
 */
function getDataApi(data) {
  return (0, _request.default)({
    url: '/admin/page/layout/category/config',
    method: 'GET',
    data: data
  });
}

/**
 * @description 保存设置
 */
function themeSave(params) {
  return (0, _request.default)({
    url: "/admin/system/config/saveuniq",
    method: 'post',
    params: params
  });
}

/**
 * @description 获取设置
 */
function getTheme(params) {
  return (0, _request.default)({
    url: "/admin/system/config/getuniq",
    method: 'get',
    params: params
  });
}

// 获取活动配置数据
function getSolarTerms(params) {
  return (0, _request.default)({
    url: "/admin/page/layout/solarTerms/getSolarTerms",
    method: 'get',
    params: params
  });
}
// 保存活动配置数据
function saveSolarTerms(data) {
  return (0, _request.default)({
    url: "/admin/page/layout/batchSolarTerms/save",
    method: 'post',
    data: data
  });
}

//  获取活动列表数据
function getActivityPageList(params) {
  return (0, _request.default)({
    url: "/admin/article/getActivityPageList",
    method: 'get',
    params: params
  });
}

// 活动页详情
function getActivityPageDetail(params) {
  return (0, _request.default)({
    url: "/admin/article/getActivityPageDetail",
    method: 'get',
    params: params
  });
}

// 保存活动页
function saveActivityPage(data) {
  return (0, _request.default)({
    url: "/admin/article/saveActivityPage",
    method: 'post',
    data: data
  });
}
// 删除活动页
function deleteActivityPage(data) {
  return (0, _request.default)({
    url: "/admin/article/deleteActivityPage",
    method: 'post',
    params: data
  });
}

// 启用活动页
function startActivityPage(data) {
  return (0, _request.default)({
    url: "/admin/article/startActivityPage",
    method: 'post',
    data: data
  });
}